/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

class Footer extends Component {
    render() {
    return(
        <footer id="footer" className="mt-5 bg-black text-white px-2 py-4">
        <div className="flex flex-row space-x-4 justify-between items-center p-4">
          <div>
            <a href='https://www.pasteur.fr'>
              <div className="flex flex-row space-x-2 hover:text-blue-700">
                <div>
                    <img className="self-center ml-auto h-28" src="/map.png" alt="address" title="address" />
                </div>
                <div className="flex flex-col self-center">
                  <p className="whitespace-nowrap text-sm">25-28 Rue du Dr Roux,</p>
                  <p className="whitespace-nowrap text-sm">75015 Paris</p>
                  <p className="whitespace-nowrap text-sm">01 45 68 80 00</p>
                </div>
              </div>
            </a>
          </div>
          <div className="flex flex-col border-l-4 px-2 border-blue-700">
            <Link to={'/about#about'} className=" text-white hover:text-blue-700">About</Link>
            <Link to={'/about#policy'} className=" text-white hover:text-blue-700">Privacy Policy</Link>
            <Link to={'/tutorials'} className=" text-white hover:text-blue-700">Tutorials</Link>
          </div>
          <div className="flex flex-col border-l-4 px-2 border-blue-700">
            <Link to={'/credits'} className=" text-white hover:text-blue-700">Credits</Link>
            <Link to={'/how'} className=" text-white hover:text-blue-700">How to cite?</Link>
            <Link to={'/news'} className=" text-white hover:text-blue-700">Latest News</Link>
          </div>
          <div>
            <a href='https://www.lafondation3ds.org/fr/'><img className="h-28 rounded" src="/lafondation-logo.svg" alt="fondation" title="fondation" /></a>
          </div>
        </div>
        <div className="flex flex-row space-x-4 p-4">
        <p className="w-full text-center"><small>This website is free to use under the terms of the GNU Affero General Public License, which permits unrestricted use, distribution, and reproduction in any medium, provided the original work is properly cited.</small></p>
        </div>
      </footer> 
    )
    }
}

export default Footer;